import { inventar } from "./inventar.client.service";

export const api = { inventar };
